import { ObjectType, Field, ID } from 'type-graphql'
import { Kpi } from '../kpi/kpi'

@ObjectType({ description: 'KPI 경고/알림 엔티티. KPI 실적, 등급, 목표 미달 등 경고/알림 정보를 제공.' })
export class KpiAlert {
  @Field(type => ID)
  id: string

  @Field(type => Kpi, { nullable: true, description: '경고/알림이 발생한 KPI.' })
  kpi?: Kpi

  @Field({ description: '경고/알림 메시지.' })
  message: string

  @Field({ description: '경고 레벨(예: warning, critical, info 등).' })
  level: string

  @Field({ description: '경고/알림 발생 시각.' })
  createdAt: Date
}
